<template>
  <div>
    <Page :title="pageTitle">
      <template v-slot:action>
        <div class="Polaris-Page-Header__PrimaryActionWrapper">
          <div class="Polaris-Box Polaris-Box--printHidden">
            <button
              class="Polaris-Button mr-2"
              type="button"
              @click="openTemplates"
            >
              <span class="Polaris-Button__Content">
                <span class="Polaris-Button__Text">Templates</span>
              </span>
            </button>
            <button
              class="Polaris-Button Polaris-Button--primary"
              type="button"
              @click="refreshCurrentPage"
              :disabled="isLoading"
            >
              <span class="Polaris-Button__Content">
                <span class="Polaris-Button__Text">Refresh</span>
              </span>
            </button>
          </div>
        </div>
      </template>
      <template v-slot:default>
        <div class="flex flex-col max-w-7xl mx-auto my-10">
          <div
            class="-my-2 py-2 overflow-x-auto sm:-mx-6 sm:px-6 lg:-mx-8 lg:px-8"
          >
            <div v-if="isLoading">
              <Spinner />
            </div>

            <div class="flex flex-col">
              <div
                class="-my-2 py-2 overflow-x-auto sm:-mx-6 sm:px-6 lg:-mx-8 lg:px-8 "
              >
                <ManualMessageAlert />
                <div
                  v-if="checkouts.docs && checkouts.docs.length > 0"
                  class="align-middle inline-block min-w-full shadow  sm:rounded-lg border-b border-gray-200 mb-8"
                >
                  <div class="Polaris-Card">
                    <div class="">
                      <div class="Polaris-DataTable__Navigation">
                        <button
                          class="Polaris-Button Polaris-Button--disabled Polaris-Button--plain Polaris-Button--iconOnly"
                          aria-label="Scroll table left one column"
                          aria-disabled="true"
                          type="button"
                          tabindex="-1"
                        >
                          <span class="Polaris-Button__Content">
                            <span class="Polaris-Button__Icon">
                              <span class="Polaris-Icon">
                                <span
                                  class="Polaris-Text--root Polaris-Text--bodySm Polaris-Text--regular Polaris-Text--visuallyHidden"
                                >
                                </span>
                                <svg
                                  viewBox="0 0 20 20"
                                  class="Polaris-Icon__Svg"
                                  focusable="false"
                                  aria-hidden="true"
                                >
                                  <path
                                    d="M12 16a.997.997 0 0 1-.707-.293l-5-5a.999.999 0 0 1 0-1.414l5-5a.999.999 0 1 1 1.414 1.414l-4.293 4.293 4.293 4.293a.999.999 0 0 1-.707 1.707z"
                                  ></path>
                                </svg>
                              </span>
                            </span>
                          </span>
                        </button>
                        <button
                          class="Polaris-Button Polaris-Button--plain Polaris-Button--iconOnly"
                          aria-label="Scroll table right one column"
                          type="button"
                        >
                          <span class="Polaris-Button__Content">
                            <span class="Polaris-Button__Icon">
                              <span class="Polaris-Icon">
                                <span
                                  class="Polaris-Text--root Polaris-Text--bodySm Polaris-Text--regular Polaris-Text--visuallyHidden"
                                >
                                </span>
                                <svg
                                  viewBox="0 0 20 20"
                                  class="Polaris-Icon__Svg"
                                  focusable="false"
                                  aria-hidden="true"
                                >
                                  <path
                                    d="M8 16a.999.999 0 0 1-.707-1.707l4.293-4.293-4.293-4.293a.999.999 0 1 1 1.414-1.414l5 5a.999.999 0 0 1 0 1.414l-5 5a.997.997 0 0 1-.707.293z"
                                  ></path>
                                </svg>
                              </span>
                            </span>
                          </span>
                        </button>
                      </div>
                      <div
                        class="Polaris-DataTable Polaris-DataTable__ShowTotals overflow-hidden"
                      >
                        <div class="">
                          <table class="Polaris-DataTable__Table">
                            <thead>
                              <tr class="hidden md:table-row">
                                <th
                                  data-polaris-header-cell="true"
                                  class="Polaris-DataTable__Cell Polaris-DataTable__Cell--verticalAlignTop Polaris-DataTable__Cell--header"
                                  scope="col"
                                >
                                  Customer
                                </th>
                                <th
                                  data-polaris-header-cell="true"
                                  class="Polaris-DataTable__Cell Polaris-DataTable__Cell--verticalAlignTop Polaris-DataTable__Cell--header "
                                  scope="col"
                                >
                                  Date
                                </th>
                                <th
                                  data-polaris-header-cell="true"
                                  class="Polaris-DataTable__Cell Polaris-DataTable__Cell--verticalAlignTop Polaris-DataTable__Cell--header "
                                  scope="col"
                                >
                                  Recovery Status
                                </th>
                                <th
                                  data-polaris-header-cell="true"
                                  class="Polaris-DataTable__Cell Polaris-DataTable__Cell--verticalAlignTop Polaris-DataTable__Cell--header "
                                  scope="col"
                                >
                                  Message Status
                                </th>
                                <th
                                  data-polaris-header-cell="true"
                                  class="Polaris-DataTable__Cell Polaris-DataTable__Cell--verticalAlignTop Polaris-DataTable__Cell--header "
                                  scope="col"
                                >
                                  Checkout id
                                </th>
                                <th
                                  data-polaris-header-cell="true"
                                  class="Polaris-DataTable__Cell Polaris-DataTable__Cell--verticalAlignTop Polaris-DataTable__Cell--header "
                                  scope="col"
                                >
                                  Total & last order date
                                </th>
                                <th
                                  data-polaris-header-cell="true"
                                  class="Polaris-DataTable__Cell Polaris-DataTable__Cell--verticalAlignTop Polaris-DataTable__Cell--header "
                                  scope="col"
                                >
                                  Tags
                                </th>
                                <th
                                  data-polaris-header-cell="true"
                                  class="Polaris-DataTable__Cell Polaris-DataTable__Cell--verticalAlignTop Polaris-DataTable__Cell--header "
                                  scope="col"
                                ></th>
                              </tr>
                            </thead>
                            <tbody>
                              <CartListItem
                                v-for="checkout in checkouts.docs"
                                :key="checkout.id"
                                :checkout="checkout"
                                @refreshCurrentPage="refreshCurrentPage"
                                @openCustomerInfo="openCustomerInfo"
                              />
                            </tbody>
                          </table>
                        </div>

                        <Pagination :page="checkouts" @pageChanged="loadPage" />
                      </div>
                    </div>
                  </div>
                </div>
                <div
                  class="align-middle inline-block min-w-full  overflow-hidden text-center py-16"
                  v-if="
                    !isLoading && checkouts.docs && checkouts.docs.length === 0
                  "
                >
                  You don't have any abandoned carts right now. We will be
                  listing them here as soon a cart is abandoned.
                </div>
              </div>
            </div>
            <CustomerInfoModal
              v-if="showCustomerInfoModal"
              :phoneNumber="currentCustomerPhoneNumber"
              @close="closeCustomerInfo"
            />
          </div>
        </div>
      </template>
    </Page>
  </div>
</template>

<script>
import Spinner from "vue-simple-spinner";

import Page from "./Page";

import CartListItem from "./CartListItem";
import Pagination from "./Pagination";
import ManualMessageAlert from "./ManualMessageAlert";
import CustomerInfoModal from "./CustomerInfoModal.vue";

export default {
  name: "AbadonedCartList",
  data() {
    return {
      pageTitle: "Abandoned carts",
      isLoading: false,
      currentCustomerPhoneNumber: null,
      showCustomerInfoModal: false
    };
  },
  components: {
    Page,
    CartListItem,
    Pagination,
    Spinner,
    ManualMessageAlert,
    CustomerInfoModal
  },
  computed: {
    checkouts() {
      return this.$store.getters.getCheckouts;
    },
    config() {
      return this.$store.getters.getConfig;
    }
  },
  created() {
    this.loadPage(1);
    this.$store.dispatch("getTemplates");
    this.$store.dispatch("getConfig");
  },
  mounted() {
    // eslint-disable-next-line
    // googleTranslateElementInit();
  },
  methods: {
    async loadPage(page) {
      this.isLoading = true;
      await this.$store.dispatch("getAbadonedCarts", { page });
      this.isLoading = false;
    },
    refreshCurrentPage() {
      const page = this.checkouts.page;
      this.loadPage(page);
    },
    openTemplates() {
      this.$router.push({ name: "Templates" });
    },
    openCustomerInfo(phoneNumber) {
      this.currentCustomerPhoneNumber = phoneNumber;
      this.showCustomerInfoModal = true;
    },
    closeCustomerInfo() {
      this.showCustomerInfoModal = false;
    }
  }
};
</script>

<style lang="scss" scoped></style>
